import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import FloatingContact from '../../components/feature/FloatingContact';
import { useEffect } from 'react';

const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />

      {/* Hero Section */}
      <section className="pt-24 md:pt-32 pb-12 md:pb-20 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-16 items-center">
            <div className="md:col-span-5">
              <div className="w-full aspect-[3/4] overflow-hidden rounded-sm">
                <img
                  src="https://static.readdy.ai/image/f7a5d02425e0675ec2bf06c3a77d9570/7ee3e50a1c568933167cc41b8637c25f.jpeg"
                  alt="Levent Atalay - Mimar"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>
            <div className="md:col-span-7">
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl text-dark-gray leading-tight mb-6">
                Levent<br />Atalay
              </h1>
              <p className="font-sans text-sm md:text-base text-mid-gray leading-relaxed max-w-xl">
                Mimarlığı yalnızca yapı üretimi olarak değil, mekân ile insan arasındaki ilişkiyi kuran bir disiplin olarak ele alan bir yaklaşım
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Biography Section */}
      <section className="py-12 md:py-16 lg:py-20 bg-white">
        <div className="max-w-4xl mx-auto px-6 md:px-8 lg:px-20">
          <article className="prose prose-lg max-w-none">
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6 md:mb-8">
              Levent Atalay, mimarlık pratiğini estetik sadelik, fonksiyonel mükemmellik ve zamansız tasarım ilkeleri üzerine inşa etmiştir. Modern mimari anlayışı, mekânın yalnızca fiziksel bir çevre olmadığı, aynı zamanda kullanıcılarıyla derin bir diyalog kurduğu fikrine dayanır.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6 md:mb-8">
              Kariyeri boyunca konut, ticari alan ve özel projelerde mimari kimliği güçlü, özgün mekânlar üretmiştir. Her projede, işlev ve estetiğin dengeli birlikteliğini sağlayarak, kullanıcı deneyimini merkeze alan çözümler geliştirmiştir.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed mb-6 md:mb-8">
              Tasarım sürecinde minimalizm, doğal ışık kullanımı, malzeme seçimi ve mekânsal akış gibi temel unsurları titizlikle değerlendirir. Bu yaklaşım, her projenin kendine özgü karakterini korurken, zamansız bir estetik dil yaratmasını sağlar.
            </p>
            <p className="font-serif text-base md:text-lg text-dark-gray leading-relaxed">
              Levent Atalay'ın mimari vizyonu, yapılı çevrenin insan yaşamına kattığı değeri artırmak ve her mekânı anlamlı bir deneyime dönüştürmek üzerine kuruludur.
            </p>
          </article>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="py-16 md:py-20 lg:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-6 md:px-8 lg:px-20">
          <div className="text-center mb-12 md:mb-16">
            <h2 className="font-serif text-3xl md:text-4xl text-dark-gray mb-3 md:mb-4">Uzmanlık Alanları</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10 lg:gap-12">
            <div className="text-center px-4">
              <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 mx-auto mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-home-5-line text-3xl md:text-4xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-lg md:text-xl font-medium text-dark-gray mb-3 md:mb-4">
                Konut Projeleri
              </h3>
              <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                Modern yaşam alanları tasarımında fonksiyonel çözümler ve estetik mükemmellik
              </p>
            </div>

            <div className="text-center px-4">
              <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 mx-auto mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-building-line text-3xl md:text-4xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-lg md:text-xl font-medium text-dark-gray mb-3 md:mb-4">
                Ticari Alanlar
              </h3>
              <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                Kurumsal kimliği yansıtan, kullanıcı odaklı ticari mekân tasarımları
              </p>
            </div>

            <div className="text-center px-4">
              <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 mx-auto mb-4 md:mb-6 flex items-center justify-center">
                <i className="ri-pencil-ruler-2-line text-3xl md:text-4xl text-dark-gray"></i>
              </div>
              <h3 className="font-sans text-lg md:text-xl font-medium text-dark-gray mb-3 md:mb-4">
                Özel Projeler
              </h3>
              <p className="text-mid-gray text-xs md:text-sm leading-relaxed">
                Özgün konseptler ve özelleştirilmiş mimari çözümlerle benzersiz mekânlar
              </p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
